(function (app) {
    app.provider("figOverlay", [function () {
        this.$get = [function () {
            var service = {};
            var startFuncs = [];
            var endFuncs = [];

            service.onStart = function (func) {
                startFuncs.push(func);

                return function () {
                    startFuncs.splice(startFuncs.indexOf(func), 1);
                };
            };

            service.onEnd = function (func) {
                endFuncs.push(func);

                return function () {
                    endFuncs.splice(endFuncs.indexOf(func), 1);
                };
            };

            service.start = function () {
                startFuncs.forEach(function (f) { f(); });
            };

            service.end = function () {
                endFuncs.forEach(function (f) { f(); });
            };

            return service;
        }];
    }]);

    app.directive("figOverlay", ["figOverlay", function (figOverlay) {
        return {
            restrict: "E",
            link: function (scope, elem) {
                var onDestroy = [];

                onDestroy.push(figOverlay.onStart(function () {
                    elem[0].style.zIndex = 99;
                    elem[0].style.opacity = 0.5;
                }));

                onDestroy.push(figOverlay.onEnd(function () {
                    elem[0].style.zIndex = -1;
                    elem[0].style.opacity = 0;
                }));

                elem.on("$destroy", function () {
                    onDestroy.forEach(function (func) {
                        func();
                    });
                });
            }
        };
    }]);

    app.directive("figOverlayElement", ["figOverlay", function (figOverlay) {
        return {
            restrict: "E",
            link: function (scope, elem) {
                var onDestroy = [];

                onDestroy.push(figOverlay.onStart(function () {
                    elem[0].style.zIndex = 100;
                }));

                onDestroy.push(figOverlay.onEnd(function () {
                    elem[0].style.zIndex = -1;
                }));

                elem.on("$destroy", function () {
                    onDestroy.forEach(function (func) {
                        func();
                    });
                });
            }
        };
    }]);

    app.directive("figOverlayDisabled", ["figOverlay", function (figOverlay) {
        return {
            restrict: "E",
            link: function (scope, elem) {
                var onDestroy = [];

                onDestroy.push(figOverlay.onStart(function () {
                    elem[0].style.pointerEvents = "none";
                }));

                onDestroy.push(figOverlay.onEnd(function () {
                    elem[0].style.pointerEvents = "auto";
                }));

                elem.$on("$destroy", function () {
                    onDestroy.forEach(function (func) {
                        func();
                    });
                });
            }
        };
    }]);
})(window.app); // jshint ignore:line